import { type MutableRefObject, useEffect, useRef } from 'react';
function loadScript(src: string, position: HTMLElement | null, id: string) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}
export const useBooqable = (): MutableRefObject<boolean> => {
  const loaded = useRef(false);
  useEffect(() => {
    //@ts-ignore
    window.booqableOptions = {
      company: 'da4d6c20-f077-4bcd-a57e-82c0574dc426',
    };
    if (typeof window !== 'undefined' && !loaded.current) {
      loadScript(
        `https://da4d6c20-f077-4bcd-a57e-82c0574dc426.assets.booqable.com/v2/booqable.js`,
        document.querySelector('head'),
        'booqable-js',
      );
    }
    loaded.current = true;
  }, []);
  return loaded;
};
